import { Col, Row } from "react-bootstrap"
import { useHistory } from "react-router-dom"
import { IoIosCloseCircle } from "react-icons/io";

import useQuery from "../../hook/useQuery";
import FormDoctor from "../../components/doctor/FormDoctor";

import '../../styles/doctores/doctores.css'
import useCompanyType from "../../hook/useCompanyType";
import FormDoctorCLB from "../../components/doctor/FormDoctorCLB";

function AddDoctor(){
    const history = useHistory();
    const query = useQuery()
    const id = query.get('id')
    const companyType = useCompanyType()

    return (
        <>
            <div className="body">
                <Row className="align-items-center">
                    <Col xs="12" md="8">
                        <h2 className="mb-0 title-top">{`${id ? 'Editar información del ' :'Agregar '}doctor` }</h2>
                    </Col>
                    <Col xs="12" md="4" className="text-right">
                        <IoIosCloseCircle className="cancel-btn" onClick={e=>history.goBack()}/>
                    </Col>
                </Row>
                {
                companyType === "colombia" ? 
                    <FormDoctorCLB history={history} id={id} />:
                    <FormDoctor history={history} id={id} />
                } 
                
            </div>
        </>
    )
}

export default AddDoctor